import { noop } from 'lodash'
import { createContext } from 'react'

type TLeasingQualifiedContext = {
  toggleLeasingQualifiedFilter: () => void
  isLeasingQualifiedFilterEnabled: boolean
}
export const LeasingQualifiedContext = createContext<TLeasingQualifiedContext>({
  toggleLeasingQualifiedFilter: noop,
  isLeasingQualifiedFilterEnabled: false,
})
